import { render, staticRenderFns } from "./VerifyProvider.vue?vue&type=template&id=84eca3ee&scoped=true"
import script from "./VerifyProvider.vue?vue&type=script&lang=js"
export * from "./VerifyProvider.vue?vue&type=script&lang=js"
import style0 from "./VerifyProvider.vue?vue&type=style&index=0&id=84eca3ee&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84eca3ee",
  null
  
)

export default component.exports